/**
 * Recently-used assets for the V2 picker ("Recently Used" tab, like HeyGen's).
 * Stored per-browser in localStorage, capped, newest-first, deduped by id.
 */

export interface RecentAsset {
  kind: 'avatar' | 'voice' | 'style' | 'brand';
  id: string;
  label: string;
  imageUrl?: string;
  previewAudioUrl?: string;
}

const KEY = 'vivideo_v2_recent_assets';
const CAP = 24;

function readAll(): RecentAsset[] {
  const raw = window.localStorage.getItem(KEY);
  if (!raw) return [];
  const parsed: unknown = JSON.parse(raw);
  return Array.isArray(parsed) ? (parsed as RecentAsset[]) : [];
}

export function getRecents(kind: RecentAsset['kind']): RecentAsset[] {
  let all: RecentAsset[] = [];
  // localStorage can throw in private windows — recents are best-effort only.
  try { all = readAll(); } catch { return []; }
  return all.filter((a) => a.kind === kind);
}

export function pushRecent(item: RecentAsset): void {
  try {
    const all = readAll().filter((a) => !(a.kind === item.kind && a.id === item.id));
    all.unshift(item);
    window.localStorage.setItem(KEY, JSON.stringify(all.slice(0, CAP)));
  } catch { /* best-effort */ }
}
